module.exports = __webpack_public_path__ + "img/VL_01_02.3f70d347.png";